import Icon from "./IconBase.js";
import PropTypes from "prop-types";

const ThumbsUpIcon = ({ color = "#757575", ...props }) => {
  return (
    <Icon
      width="25"
      height="24"
      viewBox="0 0 25 24"
      style={{ borderColor: "black" }}
      {...props}
    >
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.89581 7.51113C3.107 7.27181 3.3667 7.08016 3.65764 6.94891C3.94859 6.81766 4.26413 6.74981 4.58331 6.74988H9.83331V5.24988C9.83331 4.25532 10.2284 3.30149 10.9317 2.59823C11.6349 1.89497 12.5888 1.49988 13.5833 1.49988C13.7226 1.49978 13.8593 1.53849 13.9778 1.61169C14.0964 1.68488 14.1922 1.78965 14.2546 1.91425L17.7964 8.99988H21.8333C22.2311 8.99988 22.6127 9.15791 22.894 9.43922C23.1753 9.72052 23.3333 10.1021 23.3333 10.4999V18.7499C23.3333 19.1477 23.1753 19.5292 22.894 19.8105C22.6127 20.0918 22.2311 20.2499 21.8333 20.2499H5.70831C5.16015 20.2501 4.63078 20.0501 4.21959 19.6876C3.80841 19.3251 3.54371 18.825 3.47519 18.2811L2.35019 9.28113C2.31031 8.96427 2.33835 8.64256 2.43242 8.33738C2.5265 8.0322 2.68446 7.75054 2.89581 7.51113ZM21.8333 10.4999H18.0833V18.7499H21.8333V10.4999ZM3.83894 9.09363L4.96394 18.0936C4.98678 18.2749 5.07501 18.4416 5.21207 18.5625C5.34913 18.6833 5.52559 18.7499 5.70831 18.7499H16.5833V9.92706L13.1418 3.043C12.6317 3.14509 12.1727 3.42077 11.843 3.82314C11.5133 4.2255 11.3332 4.72968 11.3333 5.24988V7.49988C11.3333 7.69879 11.2543 7.88956 11.1136 8.03021C10.973 8.17086 10.7822 8.24988 10.5833 8.24988H4.58331C4.47688 8.24984 4.37167 8.27246 4.27465 8.31622C4.17764 8.35998 4.09105 8.42389 4.02064 8.5037C3.95023 8.58351 3.89761 8.67739 3.86629 8.77911C3.83496 8.88082 3.82563 8.98803 3.83894 9.09363Z"
          fill={color}
        />
      </svg>
    </Icon>
  );
};
ThumbsUpIcon.propTypes = {
  color: PropTypes.string,
};
export default ThumbsUpIcon;
